export default "__VITE_ASSET__CeKA0PYO__"